import * as React from 'react';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BookmarksContext from './context/BookmarkContext';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

export default function CustomizedBreadcrumbs({ handleOpenDrawerBookmark }) {

  const { bookmarks } = React.useContext(BookmarksContext)


  return (
    <div role="presentation" >
      <Breadcrumbs aria-label="breadcrumb">
        {/* <StyledBreadcrumb
          component="a"
          href="#"
          label="Home"
          icon={<HomeIcon fontSize="small" />}
        /> */}

        {/* Render bookmarks as breadcrumbs */}
        {bookmarks?.map((bookmark, index) => (
          <StyledBreadcrumb
            key={index}
            component="a"
            href="#"
            onClick={() => handleOpenDrawerBookmark(bookmark)}
            label={`[${bookmark?.f14}] ${bookmark?.f12} ` || 'Unnamed Bookmark'} // Use f36 value or a fallback
          />
        ))}
      </Breadcrumbs>
    </div>
  );
}
